import React, { useState, useEffect, useRef, useMemo } from 'react';
import parser from 'html-react-parser';
import {
  HtmlEditor,
  Image,
  Inject,
  Link,
  QuickToolbar,
  RichTextEditorComponent,
  Toolbar
} from '@syncfusion/ej2-react-richtexteditor';
import {
  Lock,
  Update,
  ReProcess,
  PollProgress,
  Get,
  GetHistory,
  Feedback,
  SaveReference
} from '../../apis/Narratives';
import { toastError } from '../../utils/toast';
import { Spinner } from '@material-tailwind/react';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import DiffMatchPatch from 'diff-match-patch';
import '../FeedbackSystem.css';

export function PlaceHolder(props) {

  const handleChange = async (data) => {
    await update();
    data.startUpdate = true;
    data.subList = props.data.subList;
    data.subList.map(sub => sub.narrativeText = sub.pkid == props.data.pkid ? rteObj.current.getHtml() : sub.narrativeText);
    props.updateData(data);
  };
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const [showPopup, setShowPopup] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [spinnerText, setSpinnerText] = useState('');
  const [lockFlag, setLockFalg] = useState(props.data.lock ?? false);
  const [focused, setFocused] = useState(false);
  const [openDialog, setopenDialog] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [narrativeText, setNarrativeText] = useState(props.data.narrativeText);
  const [customSelect, setCustomSelect] = useState(false);
  const [showHistoryDetail, setShowHistoryDetail] = useState(false);
  const [historyDetail, setHistoryDetail] = useState(false);
  const [historyNavIndex, setHistoryNavIndex] = useState(0);
  const [showDiffChecked, setShowDiffChecked] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [feedbackOption, setFeedbackOption] = useState('Not accurate');
  const [comments, setComments] = useState('');
  const [rating, setRating] = useState(props.data.rate ?? 0);
  const [pkid, setPkid] = useState('');
  const [isEditorReadOnly, setIsEditorReadOnly] = useState(props.data.lock ?? false);

  const divRef = useRef(null);
  const rteObj = useRef(null);
  const divHisRef = useRef(null);
  const divHisTextRef = useRef(null);
  const isFirstChangeRef = useRef(true);

  let customToolBar = [
    {
      template: `<span style="font-weight: bold; margin-right: 12px; width:500px">${props.data.narrativeTypeName}</span>`,
      tooltipText: 'Section Title',
      id: 'section-title'
    },
    {
      template:
        '<button type="button" class="e-tbar-btn e-btn" tabindex="-1" id="custom_tbar_help"><div class="e-tbar-btn-text" style="font-weight: 800;line-height: 25px;">Rewrite</div></button>',
      click: () => {
        setopenDialog(true);
      },
      tooltipText: 'Rewrite',
      text: 'ReProcess',
      id: props.data.pkid
    },
    {
      template:
        '<select class="my-custom-select"><option>Add history</option><option>Add history2</option><option>Add history</option></select>',
      click: () => {},
      tooltipText: 'Narrative History',
      id: props.data.pkid
    },
    {
      template: `<button type="button" class="e-tbar-btn e-btn" tabindex="-1"><i class="fas fa-save" style="min-width: 24px;line-height: 25px;"></i></button>`,
      tooltipText: 'Save',
      text: 'Save',
      click: () => {
        update();
      },
      id: props.data.pkid
    },
    {
      template: `<button type="button" class="e-tbar-btn e-btn" tabindex="-1"><i class="fas fa-notes-medical" style="min-width: 24px;line-height: 25px;"></i></button>`,
      tooltipText: 'Save Reference',
      text: 'Save Reference',
      click: () => {
        saveReference();
      },
      id: props.data.pkid
    },
    {
      template: `<button type="button" class="e-tbar-btn e-btn" tabindex="-1"><i style="min-width: 24px;line-height: 25px;" class="fas fa-lock-open"></i></button>`,
      tooltipText: 'Lock',
      text: 'Lock',
      id: props.data.pkid
    },
    {
      template: `
        <div class="e-tbar-rating" title="Rate" style="display: ${props.data.pkid === '00000000-0000-0000-0000-000000000000' ? 'none' : 'block'};">
          <div class="star-rating" style="display: flex; align-items: center;">
            <p class="star stari" tabindex="0" data-star="1" data-pkid="${props.data.pkid}"><i class="fa-regular fa-star"></i></p>
            <p class="star stari" tabindex="0" data-star="2" data-pkid="${props.data.pkid}"><i class="fa-regular fa-star"></i></p>
            <p class="star stari" tabindex="0" data-star="3" data-pkid="${props.data.pkid}"><i class="fa-regular fa-star"></i></p>
            <p class="star stari" tabindex="0" data-star="4" data-pkid="${props.data.pkid}"><i class="fa-regular fa-star"></i></p>
            <p class="star" tabindex="0" data-star="5" data-pkid="${props.data.pkid}"><i class="fa-regular fa-star"></i></p>
          </div>
        </div>
      `,
      tooltipText: 'Rate',
      id: props.data.pkid,
      text: 'Rate',
      click: () => {}
    }
  ];

  const narrativeOption = () => {
    var check = undefined;
    if (props.data.subList && props.data.subList.length > 1) {
      check = props.data.subList.map((i) => (
        {
          template: `<button type="button" class="e-tbar-btn e-btn" tabindex="-1">
          <i class="${props.data.pkid == i.pkid ? 'fas fa-circle-dot' : 'far fa-circle'}" style="color:#eaa700; min-width: 24px;line-height: 25px; margin-left:-12px"></i>
          ${i.narrativeOptionName}
          </button>`,
          tooltipText: 'Narrative Option',
          text: 'Narrative Option',
          click: () => {
            handleChange(i)
          },
          id: i.pkid
        }));
    };

    if (check) {
      return check;
    }
    return '';
  };

  const rate = (stars, pkid) => {
    setRating(stars);
    setPkid(pkid);
    setShowSpinner(true);
    setSpinnerText('Submitting rating...');
    
    if (stars < 5) {
      setShowFeedbackModal(true);
      setShowSpinner(false);
    } else {
      Feedback(pkid, '', '', 5).then(() => {
        setShowSpinner(false);
        setSpinnerText('');
        // Update star display for 5-star rating
        updateStarDisplay(pkid, 5);
      }).catch((error) => {
        setShowSpinner(false);
        console.error('Rating submission failed:', error);
      });
    }
  };

  const updateStarDisplay = (pkid, rating) => {
    const stars = document.querySelectorAll(`[data-pkid="${pkid}"]`);
    stars.forEach((star, index) => {
      const starNumber = parseInt(star.getAttribute('data-star'));
      star.classList.remove('star-focused');
      if (starNumber <= rating) {
        star.classList.add('star-focused');
      }
    });
  };
  const [toolbarSettings, setToolbarSettings] = useState([]);
  useEffect(() => {
    let newToolbar = customToolBar.map((a) => {
      if (
        props.data.history?.length > 0 &&
        a.tooltipText === 'Narrative History'
      ) {
        let option = '<option selected disabled>Narrative History</option>';
        props.data.history.forEach((ele) => {
          option += `<option value=${ele.pkid}>${ele.changedOnDisplay}</option>`;
        });
        a.template = `<select class="e-rte-dropdown-btn my-custom-select-${props.data.pkid}">${option}</select>`;
      }
      return a;
    });
    newToolbar = newToolbar.filter(
      (a) =>
        props.data.history?.length > 0 || a.tooltipText != 'Narrative History'
    );
    var defaultItems = [...newToolbar, '-', ...narrativeOption()];
  
    setToolbarSettings({
      items: defaultItems.filter((a) => a !== ''),
      type: 'MultiRow',
      enableFloating: true
    });
    setTimeout(() => {
      const customSelect = document.querySelector(`.my-custom-select-${props.data.pkid}`);
      if (customSelect) {
        customSelect.addEventListener('change', handleDropdownChange);
      }
    }, 200);
  }, [props.data.history]);
  
  useEffect(() => {
    setNarrativeText(props.data.narrativeText);
  }, [props.data.narrativeText]);

  // Handle initial lock state
  useEffect(() => {
    if (rteObj.current && props.data.lock !== undefined) {
      setReadOnlyMode(props.data.lock);
    }
  }, [rteObj, props.data.lock]);

  // Ensure lock class is always correctly applied based on lock state
  useEffect(() => {
    console.log('Lock useEffect triggered - lockFlag:', lockFlag, 'rteObj.current:', !!rteObj.current);
    
    if (!rteObj.current) {
      console.log('rteObj.current not available yet');
      return;
    }
    
    // Only call setReadOnlyMode if the current readonly state doesn't match lockFlag
    // This prevents duplicate calls when the state is already correct
    if (rteObj.current.readonly !== lockFlag) {
      console.log('Calling setReadOnlyMode to sync state');
      setReadOnlyMode(lockFlag);
    } else {
      console.log('Readonly state already matches lockFlag, skipping setReadOnlyMode');
    }
    
  }, [lockFlag, rteObj]);

  const inlineMode = {
    enable: false,
    onSelection: false
  };

 
  useEffect(() => {
    async function callAsyncUpdate() {
      if (props.data.startUpdate == true) {
        await update(props.data.narrativeText);
      }
    }
    callAsyncUpdate();
  }, [props.data]);

  useEffect(() => {
    if (!rteObj) return;
  
    const timeout = setTimeout(() => {
      const stars = document.querySelectorAll('.star');
  
      stars.forEach((star) => {
        if (star._handleStarClick) {
          star.removeEventListener('click', star._handleStarClick);
        }
  
        const clickHandler = () => {
          const starNumber = parseInt(star.getAttribute('data-star'));
          const pkid = star.getAttribute('data-pkid');
          if (starNumber && pkid) {
            rate(starNumber, pkid);
          }
        };
  
        star._handleStarClick = clickHandler;
        star.addEventListener('click', clickHandler);
  
        // Set initial star state based on current rating
        const pkid = star.getAttribute('data-pkid');
        const starNumber = parseInt(star.getAttribute('data-star'));
        if (pkid === props.data.pkid && starNumber <= rating) {
          star.classList.add('star-focused');
        } else {
          star.classList.remove('star-focused');
        }
      });
    }, 0);
  
    return () => {
      clearTimeout(timeout);
      const stars = document.querySelectorAll('.star');
      stars.forEach((star) => {
        if (star._handleStarClick) {
          star.removeEventListener('click', star._handleStarClick);
        }
      });
    };
  }, [rteObj, rating]);

  const editorKey = useMemo(() => `${props.data.pkid}-${Date.now()}`, [toolbarSettings]);

  const handleToolbarClick = (args) => {
    if (args.item.text === 'Lock') {
      lock();
    }
  };

  const handleDropdownChange = (event) => {
    getHistory(event.target.value);
  };

  const handleRteClick = (event) => {
    if (!customSelect) {
      setTimeout(() => {
        setCustomSelect(true);
        let select = document.querySelector(
          `.my-custom-select-${props.data.pkid}`
        );
        if (select) {
          select.addEventListener('change', handleDropdownChange);
        }
      }, 2000);
    }
    if (lockFlag) {
      const element = divRef.current; // Access the DOM element via ref

      if (!element) return; // Ensure the element exists

      const rect = element.getBoundingClientRect();
      // Calculate relative position
      const offsetX = event.clientX - rect.left; // Mouse x relative to the element
      const offsetY = event.clientY - rect.top; // Mouse y relative to the element

      // Position the popup slightly offset from the click position
      setPopupPosition({
        top: offsetY + 10,
        left: offsetX + 10
      });
      setShowPopup(true);
    }
  };

  // Persist to server when content changes (blur or saveInterval). Syncfusion fires
  // "change" on initial value set (load/refresh) and on blur/saveInterval — skip the first.
  const handleContentChange = () => {
    if (lockFlag || !rteObj.current) return;
    if (isFirstChangeRef.current) {
      isFirstChangeRef.current = false;
      return;
    }
    update();
  };

  const handleRteBlur = async (event) => {
    const relatedElement = event.relatedTarget;
    let canUpdate =
      !relatedElement?.classList?.contains('e-tbar-btn') &&
      !relatedElement?.classList?.contains('e-rte-dropdown-btn') &&
      !(relatedElement?.getAttribute('role') == 'menu');
    canUpdate =
      canUpdate &&
      !relatedElement?.classList?.contains('e-tbar-rating') &&
      !relatedElement?.classList?.contains('star') &&
      !(relatedElement?.getAttribute('role') == 'menu');

    if (!lockFlag && focused && canUpdate) await update();
    setFocused(false);

    if (
      !(
        relatedElement &&
        relatedElement.classList &&
        relatedElement.classList.contains('lock-btn')
      )
    )
      setShowPopup(false);

    if (canUpdate || relatedElement === null) hideToolBar();
  };

  const handleRteFocus = () => {
    if (!lockFlag) {
      const comp = document.querySelector(
        `#${props.narrativeTypeCode ?? props.data.narrativeTypeCode} .e-rte-tb-float`
      );
      if (comp && comp.style) comp.style.display = '';
    }
    setFocused(true);
  };

  const getHistory = (id) => {
    GetHistory(id).then((data) => {
      rteObj.current.hideInlineToolbar();
      setHistoryDetail(data);
      setShowHistoryDetail(true);
      showHistoryDiff(showDiffChecked);
    });
  };

  const getNarrative = () => {
    setShowSpinner(true);
    setSpinnerText('Load Narrative...');
    Get(props.data.pkid).then((data) => {
      if (data) {
        setShowSpinner(false);
        setNarrativeText(data.narrativeText);
        // Only unlock if not currently locked
        if (!lockFlag) {
          setReadOnlyMode(false);
        }
      }
    });
  };

  const lock = () => {
    
    if(props.data.pkid === '00000000-0000-0000-0000-000000000000') return;

    hideToolBar();
    setShowSpinner(true);
    setSpinnerText(!lockFlag ? 'Locking...' : 'Unlocking...');
    
    const currentContent = rteObj.current.getHtml();
    setNarrativeText(currentContent);
    
    // If locking, immediately disable the editor using the proper function
    if (!lockFlag) {
      setReadOnlyMode(true);
    }
    
    Update({
      id: props.data.pkid,
      data: {
        NarrativeText: currentContent,
        NarrativeTypeId: props.data.narrativeTypeId,
        PatientId: props.clientId,
        SelectedOption: true
      }
    }).then((data) => {
      Lock(props.data.pkid).then((data) => {
        setShowSpinner(false);
        
        if (lockFlag) {
          // If unlocking, enable the editor after successful unlock
          setReadOnlyMode(false);
        }
        
        setLockFalg(!lockFlag);
        props?.onLock(props.data.pkid);
        setShowPopup(false);
      }).catch((error) => {
        // If lock operation fails, revert readonly mode
        if (!lockFlag) {
          setReadOnlyMode(false);
        }
        setShowSpinner(false);
        const msg = error?.message || (typeof error === 'string' ? error : 'Lock failed');
        toastError(`Lock failed. ${msg}. Check your connection and try again.`);
      });
    }).catch((error) => {
      // If update operation fails, revert readonly mode
      if (!lockFlag) {
        setReadOnlyMode(false);
      }
      setShowSpinner(false);
      const msg = error?.message || (typeof error === 'string' ? error : 'Save failed');
      toastError(`Save failed before locking. ${msg}. Check your connection and try again.`);
    });
  };

  const update = async (narrativeText) => {
    if (!rteObj.current) return;
    setShowSpinner(true);
    setSpinnerText('Saving changes...');
    try {
      let id = props.data.pkid;
      const data = await Update({
        id: props.data.pkid,
        data: {
          NarrativeText: narrativeText ?? rteObj.current.getHtml(),
          NarrativeTypeId: props.data.narrativeTypeId,
          PatientId: props.clientId,
          SelectedOption: true
        }
      });
      if (props.data.pkid == "00000000-0000-0000-0000-000000000000") {
        var updatedData = props.data;
        id = data.guid;
        updatedData.pkid = data.guid;
        updatedData.narrativeText = rteObj.current.getHtml();
        props.updateData(updatedData);
      } else {
        await props.refresh(props.data.pkid);
      }
    } catch (err) {
      const message =
        err?.message ||
        err?.response?.data?.message ||
        (typeof err === 'string' ? err : 'Network or server error');
      toastError(
        `Failed to save. ${message}. Check your connection and try again, or use the Save button to retry.`
      );
    } finally {
      setShowSpinner(false);
    }
  };

    const saveReference = async () => {
    setShowSpinner(true);
    setSpinnerText('Saving Reference...');
    try {
      // First update the narrative text
      await update();

      // Then save the reference
      await SaveReference({
        id: props.clientId,
        data: {
          NarrativeTypeId: props.data.narrativeTypeId
        }
      });
    } catch (err) {
      const message =
        err?.message ||
        err?.response?.data?.message ||
        (typeof err === 'string' ? err : 'Network or server error');
      toastError(
        `Failed to save reference. ${message}. Check your connection and try again.`
      );
    } finally {
      setShowSpinner(false);
    }
  };

  const setReadOnlyMode = (isReadOnly) => {
    if (!rteObj.current) {
      console.log('setReadOnlyMode: rteObj.current not available');
      return;
    }
    
    rteObj.current.focusOut();
    rteObj.current.readonly = isReadOnly;
    setIsEditorReadOnly(isReadOnly);

    if (rteObj.current.inputElement) {
      if (isReadOnly) {
        rteObj.current.hideInlineToolbar();
        rteObj.current.inputElement.classList.add('edit-narrative-editor-lock');
        console.log('setReadOnlyMode: Lock class ADDED');
      } else {
        rteObj.current.inputElement.classList.remove('edit-narrative-editor-lock');
        console.log('setReadOnlyMode: Lock class REMOVED');
      }
    } else {
      console.log('setReadOnlyMode: inputElement not available');
    }
  };

  const content = () => {
    return (
      <div className='dialogContent'>
        <span className='dialogText'>
          How can we write this section better?
        </span>
        <textarea
          style={{
            borderWidth: 1,
            borderColor: '#bdbdbd',
            width: '100%',
            padding: 5,
            borderRadius: 5,
            marginTop: 10
          }}
          onChange={(e) => setFeedback(e.target.value)}
          name='feedback'
          placeholder='Type your feedback here...'
          rows={4}
          cols={40}
        />
      </div>
    );
  };

  const FeedbackContent = () => {
    function selectRadio(selectedRadio) {
      const radios = document.querySelectorAll('input[name="feedbackOption"]');
      radios.forEach((radio) => {
        radio.checked = false;
      });
      selectedRadio.checked = true;
    }
    return (
      <div className='dialogContent'>
        <h2 className='dialogText'>Share your feedback</h2>
        <form>
          {[
            'Not accurate',
            'Missing Details',
            'Too Long',
            'Too Short',
            'Other'
          ].map((option) => (
            <label key={option}>
              <input
                type='radio'
                name='feedbackOption'
                value={option}
                onChange={(e) => {
                  setFeedbackOption(e.target.value);
                }}
                onClick={(e) => {
                  selectRadio(e.currentTarget);
                }}
                defaultChecked={option == feedbackOption}
              />
              <span> {option}</span>
              <br />
            </label>
          ))}
          <br />
          <textarea
            style={{
              borderWidth: 1,
              borderColor: '#bdbdbd',
              width: '100%',
              padding: 5,
              borderRadius: 5,
              marginTop: 10
            }}
            onChange={(e) => setComments(e.target.value)}
            name='feedback'
            placeholder='Type your feedback here...'
            rows={4}
            cols={40}
          />
        </form>
      </div>
    );
  };

  const progress = () => {
    PollProgress(props.data.pkid).then((data) => {
      if (data?.percent < 100) {
        setSpinnerText(data.message);
        setTimeout(() => {
          progress();
        }, 5000);
      } else {
        setShowSpinner(false);
        getNarrative();
      }
    });
  };

  const showHistoryDiff = (isChecked, update = false) => {
    if (isChecked) {
      let orgText = rteObj?.current?.getText();
      let oldText = divHisRef?.current?.innerText;
      var dmp = new DiffMatchPatch();
      var diff = dmp.diff_main(orgText, oldText);
      dmp.diff_cleanupSemantic(diff);
      const diffHtml = dmp.diff_prettyHtml(diff);
      divHisTextRef.current.innerHTML = diffHtml;
      divHisRef.current?.classList.add('hidden');
      divHisTextRef?.current?.classList.remove('hidden');
    } else {
      divHisRef?.current?.classList.remove('hidden');
      divHisTextRef?.current?.classList.add('hidden');
    }
    if (update) setShowDiffChecked(!showDiffChecked);
  };

  const hideToolBar = () => {
    const comp = document.querySelector(
      `#${props.narrativeTypeCode ?? props.data.narrativeTypeCode} .e-rte-tb-float`
    );
    if (comp && comp.style) comp.style.display = 'none';
  };

  let buttons = [
    {
      click: () => {
        setShowSpinner(true);
        setSpinnerText('Rewriting...');
        hideToolBar();
        ReProcess({
          id: props.data.pkid,
          data: { NarrativeText: feedback }
        }).then((data) => {
          if (data?.status) {
            setTimeout(() => {
              progress();
            }, 5000);
          }
        });

        setopenDialog(false);
      },
      buttonModel: {
        isPrimary: true,
        className: 'test',
        content: 'OK'
      }
    },
    {
      click: () => {
        setopenDialog(false);
      },
      buttonModel: {
        isPrimary: false,
        content: 'Cancel'
      }
    }
  ];

  let feedbackButtons = [
    {
      click: () => {
        setShowSpinner(true);
        setSpinnerText('Submitting...');
        hideToolBar();
        setShowFeedbackModal(false);
        Feedback(pkid, feedbackOption, comments, rating).then(() => {
          setShowSpinner(false);
          setSpinnerText('');
          // Update star display using the new function
          updateStarDisplay(pkid, rating);
        }).catch((error) => {
          setShowSpinner(false);
          console.error('Feedback submission failed:', error);
        });
      },
      buttonModel: {
        isPrimary: true,
        className: 'test',
        content: 'Submit Feedback'
      }
    },
    {
      click: () => {
        setShowFeedbackModal(false);
      },
      buttonModel: {
        isPrimary: false,
        content: 'Cancel'
      }
    }
  ];

  return (
    
    <div
      ref={divRef}
      id={props.narrativeTypeCode ?? props.data.narrativeTypeCode}
      className='edit-narrative-editor'
    >
      {showHistoryDetail && (
        <div className='history-detail'>
          <div
            className='mb-2'
            style={{
              borderBottom: '1px solid #b4aab6',
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <div style={{ alignself: 'center' }}>
              <div className='input-group'>
                <input
                  type='checkbox'
                  checked={showDiffChecked}
                  onChange={() => {
                    showHistoryDiff(!showDiffChecked, true);
                  }}
                />
                <div style={{ alignSelf: 'center' }} className='inline ml-2'>
                  Show Changes
                </div>
              </div>
            </div>
            <div style={{ alignSelf: 'center' }}>
              <i
                className={
                  historyNavIndex == 0 ? 'hidden' : 'fas fa-chevron-left mr-2'
                }
                style={{
                  border: '1px solid #8080809e',
                  padding: '5px',
                  borderRadius: '5px'
                }}
                onClick={() => {
                  getHistory(props.data.history[historyNavIndex - 1].pkid);
                  setHistoryNavIndex(historyNavIndex - 1);
                }}
              ></i>
              <i
                className={
                  historyNavIndex + 1 < props.data.history.length
                    ? 'fas fa-chevron-right mr-3'
                    : 'hidden'
                }
                style={{
                  border: '1px solid #8080809e',
                  padding: '5px',
                  borderRadius: '5px'
                }}
                onClick={() => {
                  getHistory(props.data.history[historyNavIndex + 1].pkid);
                  setHistoryNavIndex(historyNavIndex + 1);
                }}
              ></i>
            </div>
            <div class='m-2 text-right'>
              <span style={{ color: '#b4aab6' }}>
                {historyDetail.changedOnDisplay}
              </span>
              <button
                type='button'
                class='btn-submit  p-0 ml-2'
                style={{ width: 150 }}
                onClick={async () => {
                  setNarrativeText(historyDetail.narrativeText);
                  setShowHistoryDetail(false);
                  await update(historyDetail.narrativeText);
                }}
              >
                <div style={{ fontsize: 'small' }} className='d-inline'>
                  Apply{' '}
                </div>
              </button>
              <i
                className='fas fa-times-circle ml-2'
                style={{ fontsize: '25px', color: '#b4aab6' }}
                onClick={() => {
                  setShowHistoryDetail(false);
                }}
              ></i>
            </div>
          </div>
          <div ref={divHisRef} style={{ maxHeight: 600, overflowY: 'auto' }}>
            {parser(historyDetail.narrativeText)}
          </div>
          <div
            ref={divHisTextRef}
            style={{ maxHeight: 600, overflowY: 'auto' }}
          ></div>
        </div>
      )}
      {openDialog && (
        <DialogComponent
          isModal={true}
          buttons={buttons}
          visible={openDialog}
          width='435px'
          minHeight='190px'
          content={content}
        ></DialogComponent>
      )}
      {showFeedbackModal && (
        <DialogComponent
          isModal={true}
          buttons={feedbackButtons}
          visible={showFeedbackModal}
          width='435px'
          minHeight='190px'
          content={FeedbackContent}
        ></DialogComponent>
      )}

      {showSpinner && (
        <div className='flex' style={{ background: '#fafafa', padding: 5 }}>
          <Spinner color='amber' />
          <span style={{ marginLeft: 5 }}>{spinnerText}</span>
        </div>
      )}
      {showPopup && (
        <div
          style={{
            position: 'absolute',
            top: `${popupPosition.top}px`,
            left: `${popupPosition.left}px`,
            padding: '10px',
            border: '1px solid #e0e0e0',
            backgroundColor: '#fff',
            boxShadow: '0px 0px 10px rgba(0,0,0,0.2)',
            zIndex: 100000 // Ensure the popup is above other content
          }}
        >
          <button
            type='button'
            className='e-tbar-btn e-btn lock-btn'
            tooltiptext='Unlock'
            onClick={lock}
          >
            <i className='fas fa-lock'></i>
          </button>
        </div>
      )}
      {props.hasEdit ? (
        <RichTextEditorComponent
          key={editorKey}
          ref={rteObj}
          readonly={isEditorReadOnly}
          inlineMode={inlineMode}
          onFocus={handleRteFocus}
          onClick={handleRteClick}
          onBlur={handleRteBlur}
          change={handleContentChange}
          enableHtmlSanitizer={true}
          toolbarSettings={toolbarSettings}
          toolbarClick={handleToolbarClick}
          value={narrativeText}
          saveInterval={5 * 60 * 1000}
          created={() => {
            hideToolBar();
            // Add event listener for the custom select dropdown
            const customSelect = document.querySelector('.my-custom-select');
            if (customSelect) {
              customSelect.addEventListener('change', handleDropdownChange);
            }
          }}
        >
          <Inject services={[Toolbar, Image, Link, HtmlEditor, QuickToolbar]} />
        </RichTextEditorComponent>
      ) : (
        <div> {parser(narrativeText)}</div>
      )}
    </div>
  );
}
